/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';

export default {
  data() {
    return {
      workorder: null,
    };
  },
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('Workorder', {
      errorMessage: (state) => state.errorMessage,
    }),
    isJuniorPlanner() {
      // Everyone is considered a Junior Planner until the data is finished loading
      // to prevent the button from being visible and then having it disappear again
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return true;
      const groups = this.memberOf.map((e) => e.displayName);
      const isJuniorPlanner = groups.includes('Acorn Junior Planner');
      return isJuniorPlanner;
    },
    isWorkOrderSubmitForReviewMember() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const roles = this.config.workOrderForm.submitForReviewRoles;
      return this.memberOf.filter((item) => roles.includes(item.displayName)).length > 0;
    },
    isWorkOrderSubmitToVendorMember() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const roles = this.config.workOrderForm.submitToVendorRoles;
      return this.memberOf.filter((item) => roles.includes(item.displayName)).length > 0;
    },
    isWorkOrderAcceptedByVendorMember() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const roles = this.config.workOrderForm.acceptedByVendorRoles;
      return this.memberOf.filter((item) => roles.includes(item.displayName)).length > 0;
    },
    isWorkOrderCompleteMember() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const roles = this.config.workOrderForm.completeRoles;
      return this.memberOf.filter((item) => roles.includes(item.displayName)).length > 0;
    },
    isWorkOrderCancelMember() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const roles = this.config.workOrderForm.cancelRoles;
      return this.memberOf.filter((item) => roles.includes(item.displayName)).length > 0;
    },
  },
  methods: {
    isWorkorderSubmitForReviewVisible(workorder) {

      let isVisible = false;

      if (!this.config) return isVisible;

      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Draft:
          isVisible = true;
          break;
        default:
          isVisible = false;
      }

      return isVisible;
    },
    isWorkorderSubmitToVendorVisible(workorder) {

      let isVisible = false;

      if (!this.config) return isVisible;

      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Draft:
          isVisible = true;
          break;
        case this.config.workOrderForm.submitStatus.Review:
          isVisible = true;
          break;
        default:
          isVisible = false;
      }

      return isVisible;
    },
    isWorkorderSubmitToVendorVisibleForJuniorPlanner(workorder) {

      let isVisible = false;

      if (!this.config) return isVisible;

      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Submitted:
          isVisible = true;
          break;
        default:
          isVisible = false;
      }

      return isVisible;
    },
    isWorkorderAcceptedByVendorVisible(workorder) {

      let isVisible = false;

      if (!this.config) return isVisible;

      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Submitted:
          isVisible = true;
          break;
        default:
          isVisible = false;
      }

      return isVisible;
    },

    isWorkorderCompleteDisabled(workorder) {

      if (!this.config) {
        console.warn('Exit isWorkorderCompleteDisabled(): !this.config');
        return true;
      }

      if (workorder.status !== this.config.workOrderForm.submitStatus.Accepted) {
        console.warn('Exit isWorkorderCompleteDisabled(): workorder.status !== Accepted');
        return true;
      }

      if (workorder.workOrderBills?.length) {
        const billCount = workorder.workOrderBills.length;
        const paidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Paid).length;
        const voidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Voided).length;
        if (billCount !== (paidCount + voidCount)) {
          console.warn('Exit isWorkorderCompleteDisabled(): billCount !== (paidCount + voidCount)');
          return true;
        }
      }

      if (workorder.workOrderLineItems?.length) {
        const hasIncompleteWorkOrderLineItems = workorder.workOrderLineItems.some((e) => e.billingComplete === false);
        if (hasIncompleteWorkOrderLineItems) {
          console.warn('Exit isWorkorderCompleteDisabled(): hasIncompleteWorkOrderLineItems');
          return true;
        }
      }

      return false;
    },
    isWorkorderCompleteDisabledTitle(workorder) {

      if (!this.config) return 'Loading...';

      if (workorder.status !== this.config.workOrderForm.submitStatus.Accepted) {
        return 'This action only applies to accepted Work Orders';
      }

      if (workorder.workOrderBills && workorder.workOrderBills !== null && workorder.workOrderBills.length > 0) {
        const billCount = workorder.workOrderBills.length;
        const paidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Paid).length;
        const voidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Voided).length;
        if (billCount !== (paidCount + voidCount)) {
          return 'You cannot complete this Work Order because one or more Bills remain unpaid and/or unvoided';
        }
      }

      if (workorder.workOrderLineItems && workorder.workOrderLineItems !== null && workorder.workOrderLineItems.length > 0) {
        const isDisabled = workorder.workOrderLineItems.some((e) => e.billingComplete === false);
        if (isDisabled) {
          return 'You cannot complete this Work Order because one or more Services or Materials have incomplete billing.';
        }
      }

      return 'Complete Work Order';
    },
    isWorkorderCompleteVisible(workorder) {
      if (!this.config) return false;
      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Accepted:
          return true;
        default:
          return false;
      }
    },
    isWorkorderCancelDisabled(workorder) {

      if (workorder.workOrderBills && workorder.workOrderBills !== null && workorder.workOrderBills.length > 0) {
        const billCount = workorder.workOrderBills.length;
        const voidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Voided).length;
        if (billCount !== voidCount) {
          return true;
        }
      }

      return false;
    },
    isWorkorderCancelDisabledTitle(workorder) {

      if (workorder.workOrderBills && workorder.workOrderBills !== null && workorder.workOrderBills.length > 0) {
        const billCount = workorder.workOrderBills.length;
        const voidCount = workorder.workOrderBills.filter((e) => e.status === this.config.workOrderBillForm.submitStatus.Voided).length;
        if (billCount !== voidCount) {
          return 'This action is only available when all Bills have been Voided';
        }
      }

      return 'Cancel Work Order';
    },
    isWorkorderCancelVisible(workorder) {
      if (!this.config) return false;
      switch (workorder.status) {
        case this.config.workOrderForm.submitStatus.Draft:
          return true;
        case this.config.workOrderForm.submitStatus.Review:
          return true;
        case this.config.workOrderForm.submitStatus.Submitted:
          return true;
        case this.config.workOrderForm.submitStatus.Accepted:
          return true;
        default:
          return false;
      }
    },
    workorderSubmitForReviewOnClick(workorder) {
      this.workorder = workorder;
      if ((!this.workorder.workOrderLineItems || this.workorder.workOrderLineItems === null || this.workorder.workOrderLineItems.length === 0)
      && (!this.workorder.workOrderProjectIncentives || this.workorder.workOrderProjectIncentives === null || this.workorder.workOrderProjectIncentives.length === 0)) {
        this.$bvModal.show('workorderInvalidLineItemsModal');
      } else {
        this.$bvModal.show('workorderSubmitForReviewModal');
      }
    },
    workorderSubmitForReviewOnClickOk() {
      this.workorderSubmitOnClick(
        this.workorder,
        this.config.workOrderForm.submitStatus.Review,
      );
      if (!this.errorMessage || this.errorMessage === '') {
        window.location.href = `mailto:?subject=Work Order Needs Review&body=${this.project.projectName} - ${this.workorder.workOrderName}: ${this.workorderUrl()}`;
      }
    },
    workorderUrl() {
      return `${window.location.href.slice(0, window.location.href.lastIndexOf('workorders'))}workorders/${this.workorder.id}`;
    },
    workorderSubmitToVendorOnClick(workorder, workorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources) {
      this.workorder = workorder;
      if ((!this.workorder.workOrderLineItems || this.workorder.workOrderLineItems === null || this.workorder.workOrderLineItems.length === 0)
      && (!this.workorder.workOrderProjectIncentives || this.workorder.workOrderProjectIncentives === null || this.workorder.workOrderProjectIncentives.length === 0)) {
        this.$bvModal.show('workorderInvalidLineItemsModal');
        return;
      }

      const exceededItems = this.workOrderValid(workorder, workorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources);
      if (exceededItems.length !== 0) {
        this.$bvModal.show('workorderInvalidLineItemsTotalsModal');
        return;
      }

      this.$bvModal.show('workorderSubmitToVendorModal');
    },
    workOrderValid(workorder, workorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources) {
      const workOrderFiscalYear = this.getFiscalYear(workorder.requestedDate);
      const workOrderDistrictOrPartnerCost = this.GetWorkOrderDistrictOrPartnerCosts(workorder, projectWorkorderLineItemFundingSources);
      const workOrdersDistrictOrPartnerCost = this.GetOtherWorkOrdersDistrictOrPartnerCosts(workorder, workorders, projectWorkorderLineItemFundingSources, workOrderFiscalYear);
      const paidWorkOrderTotals = this.GetPaidWorkOrderTotals(workorders, projectWorkorderLineItemFundingSources, workOrderFiscalYear);
      const workOrderSnapshotTotal = this.GetWorkOrderSnapshotDistrictOrPartnerTotal(projectBudgetYearSnapshots, projectWorkorderLineItemFundingSources, workOrderFiscalYear);
      const workOrderAnnualIncreaseTotal = this.GetWorkOrderSnapshotAnnualAdjustmentTotal(projectBudgetYearSnapshots, projectWorkorderLineItemFundingSources, workOrderFiscalYear);

      const totals = [];
      Object.keys(workOrderDistrictOrPartnerCost).forEach((e) => {
        const workOrderCost = workOrderDistrictOrPartnerCost[e];
        const otherCost = workOrdersDistrictOrPartnerCost[e];
        const payments = paidWorkOrderTotals[e];
        const snapshotTotal = workOrderSnapshotTotal[e];
        const adjustmentTotal = workOrderAnnualIncreaseTotal[e];

        const fundingSource = fundingSources.filter((fs) => fs.recorD_ID.toString() === e.toString());
        let fundingSourceName = '';
        if (fundingSource.length === 1) {
          fundingSourceName = fundingSource[0].recorD_NAME;
        }

        const item = {
          id: e,
          name: fundingSourceName,
          total: snapshotTotal + adjustmentTotal - (workOrderCost + otherCost + payments),
        };
        totals.push(item);
      });

      const exceededItems = totals.filter((e) => e.total < 0);
      return exceededItems;
    },
    GetWorkOrderSnapshotAnnualAdjustmentTotal(projectBudgetYearSnapshots, projectWorkorderLineItemFundingSources, workOrderFiscalYear) {
      const fundingSourceIds = Array.from(new Set(
        projectWorkorderLineItemFundingSources.map(
          (e) => e.fundingSourceId,
        ),
      ));

      const adjustmentTotal = {};
      fundingSourceIds.forEach((e) => {
        adjustmentTotal[e.toString()] = 0.0;
      });

      const currentProjectBudgetYear = projectBudgetYearSnapshots.find((by) => by.year === workOrderFiscalYear);
      if (!currentProjectBudgetYear || currentProjectBudgetYear === null) {
        return [];
      }

      currentProjectBudgetYear.projectBudgetYear.annualBudgetIncreases.forEach((inc) => {
        if (adjustmentTotal[inc.fundingSourceId] !== undefined) {
          adjustmentTotal[inc.fundingSourceId.toString()] += inc.adjustmentToAnnualBudget;
        }
      });

      return adjustmentTotal;
    },
    GetWorkOrderSnapshotDistrictOrPartnerTotal(projectBudgetYearSnapshots, projectWorkorderLineItemFundingSources, workOrderFiscalYear) {
      const fundingSourceIds = Array.from(new Set(
        projectWorkorderLineItemFundingSources.map(
          (e) => e.fundingSourceId,
        ),
      ));

      const snapshotTotal = {};
      fundingSourceIds.forEach((e) => {
        snapshotTotal[e.toString()] = 0.0;
      });

      const projectBudgetLineItemSnapshots = projectBudgetYearSnapshots.filter(
        (e) => e.year === workOrderFiscalYear,
      ).map((e) => e.projectBudgetLineItemSnapshots).flat();

      projectBudgetLineItemSnapshots.forEach((e) => {
        const fsource = projectWorkorderLineItemFundingSources.find((fs) => fs.fundingSourceId.toString() === e.fundingSourceId.toString());
        if (fsource && fsource !== null && snapshotTotal[fsource.fundingSourceId.toString()] !== null) {
          const baseCost = ((e.quantity * e.unitCost) * (e.costShare * 0.01));
          const contingency = baseCost * e.contingencyPercent * 0.01;
          snapshotTotal[fsource.fundingSourceId.toString()] += (baseCost + contingency);
        }
      });

      return snapshotTotal;
    },
    GetPaidWorkOrderTotals(workorders, projectWorkorderLineItemFundingSources, workOrderFiscalYear) {
      const fundingSourceIds = Array.from(new Set(
        projectWorkorderLineItemFundingSources.map(
          (e) => e.fundingSourceId,
        ),
      ));

      const workOrdersPaidBillsTotals = {};

      fundingSourceIds.forEach((e) => {
        workOrdersPaidBillsTotals[e.toString()] = 0.0;
      });

      // workOrderBills is not part of WorkOrderOutputModel; it is grafted on client-side by
      // loadProjectWorkorderBills(). Default to [] so a work order that has not been through
      // that step does not put an undefined into the flattened list.
      const workOrderBills = workorders.filter((e) => e.status === 'Completed'
        && this.getFiscalYear(e.requestedDate) === workOrderFiscalYear).map(
        (e) => e.workOrderBills ?? [],
      ).flat();

      const workOrderBillLineItems = workOrderBills.filter((e) => e.status === 'Paid').map(
        (e) => e.workOrderBillLineItems,
      ).flat();

      workOrderBillLineItems.forEach((e) => {
        const fsource = projectWorkorderLineItemFundingSources.find((fs) => fs.workOrderLineItemId === e.workOrderLineItemId);
        workOrdersPaidBillsTotals[fsource.fundingSourceId.toString()] += ((e.quantity * e.salePrice));
      });

      return workOrdersPaidBillsTotals;
    },
    GetOtherWorkOrdersDistrictOrPartnerCosts(workorder, workorders, projectWorkorderLineItemFundingSources, workOrderFiscalYear) {
      const fundingSourceIds = Array.from(new Set(
        projectWorkorderLineItemFundingSources.map(
          (e) => e.fundingSourceId,
        ),
      ));

      const workOrdersDistrictOrPartnerCost = {};
      fundingSourceIds.forEach((e) => {
        workOrdersDistrictOrPartnerCost[e.toString()] = 0.0;
      });

      const workorderLineItems = workorders.filter((e) => e.id !== workorder.id
      && (this.getFiscalYear(e.requestedDate) === workOrderFiscalYear)
      && (e.status === 'Accepted' || e.status === 'Submitted' || e.status === 'Review')).map(
        (e) => e.workOrderLineItems,
      ).flat();

      workorderLineItems.forEach((e) => {
        const fsource = projectWorkorderLineItemFundingSources.find((fs) => fs.workOrderLineItemId === e.workOrderLineItemId);
        workOrdersDistrictOrPartnerCost[fsource.fundingSourceId.toString()] += ((e.quantity * e.salePrice) * (e.districtAndPartnerCost * 0.01));
      });

      return workOrdersDistrictOrPartnerCost;
    },
    GetWorkOrderDistrictOrPartnerCosts(workorder, projectWorkorderLineItemFundingSources) {
      const workorderLineItems = workorder.workOrderLineItems;
      const fundingSourceIds = workorderLineItems.map((e) => e.fundingSourceId);

      const workOrderDistrictOrPartnerCost = {};
      fundingSourceIds.forEach((e) => {
        workOrderDistrictOrPartnerCost[e.toString()] = 0.0;
      });

      workorderLineItems.forEach((e) => {
        const fsource = projectWorkorderLineItemFundingSources.find((fs) => fs.workOrderLineItemId === e.workOrderLineItemId);
        workOrderDistrictOrPartnerCost[fsource.fundingSourceId.toString()] += ((e.quantity * e.salePrice) * (e.districtAndPartnerCost * 0.01));
      });

      return workOrderDistrictOrPartnerCost;
    },
    workorderSubmitToVendorOnClickOk() {
      this.workorderSubmitOnClick(
        this.workorder,
        this.config.workOrderForm.submitStatus.Submitted,
      );
    },
    workorderAcceptedByVendorOnClick(workorder, workorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources) {
      this.workorder = workorder;
      if ((!this.workorder.workOrderLineItems || this.workorder.workOrderLineItems === null || this.workorder.workOrderLineItems.length === 0)
      && (!this.workorder.workOrderProjectIncentives || this.workorder.workOrderProjectIncentives === null || this.workorder.workOrderProjectIncentives.length === 0)) {
        this.$bvModal.show('workorderInvalidLineItemsModal');
        return;
      }

      const exceededItems = this.workOrderValid(workorder, workorders, projectWorkorderLineItemFundingSources, projectBudgetYearSnapshots, fundingSources);
      if (exceededItems.length !== 0) {
        this.$bvModal.show('workorderInvalidLineItemsTotalsModal');
        return;
      }

      this.$bvModal.show('workorderAcceptedByVendorModal');
    },
    workorderAcceptedByVendorOnClickOk() {
      this.workorderSubmitOnClick(
        this.workorder,
        this.config.workOrderForm.submitStatus.Accepted,
      );
    },
    workorderCompleteOnClick(workorder) {
      this.workorder = workorder;
      if ((!this.workorder.workOrderLineItems || this.workorder.workOrderLineItems === null || this.workorder.workOrderLineItems.length === 0)
      && (!this.workorder.workOrderProjectIncentives || this.workorder.workOrderProjectIncentives === null || this.workorder.workOrderProjectIncentives.length === 0)) {
        this.$bvModal.show('workorderInvalidLineItemsModal');
      } else {
        this.$bvModal.show('workorderCompleteModal');
      }
    },
    workorderCompleteOnClickOk() {
      this.workorderSubmitOnClick(
        this.workorder,
        this.config.workOrderForm.submitStatus.Completed,
      );
    },
    workorderCancelOnClick(workorder) {
      this.workorder = workorder;
      this.$bvModal.show('workorderCancelModal');
    },
    workorderCancelOnClickOk() {
      this.workorderSubmitOnClick(
        this.workorder,
        this.config.workOrderForm.submitStatus.Cancelled,
      );
    },
    workorderSubmitOnClick(workorder, status) {
      (async () => {
        await this.$store.dispatch('Workorder/setFormLoading', true);
        const model = { id: workorder.id, status };
        await this.$store.dispatch('Workorder/setWorkorderStatus', model);
        /* eslint-disable-next-line */
        workorder.status = status;

        await this.$store.dispatch(
          'Project/getProjectIncentivePayments',
          this.project.id,
        );

        await this.$store.dispatch('Workorder/setFormLoading', false);
      })();
    },
  },
};
